<div class="row">
  <div class="col-md-10">
    <div class="d-flex justify-content-start align-items-center h-100">
      <h4 class="mb-0">Total Hours of Mentorship Provided by Mentor</h4>
    </div>
  </div>
  <div class="col-md-2">
    <div class="d-flex justify-content-end align-items-center">
      <button class="btn btn-primary addbtn">Download</button>
    </div>
  </div>

  <div class="col-lg-12">
    <div class="card p-3 mt-3">
      <div class="card-block">
        <div class="table-responsive">
          <table datatable id="" class="table table-gr" width="100%">
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Mentor Name</th>
                <th>Average Meeting Time</th>
                <th>Dutation</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1.</td>
                <td>Brijesh Kumar</td>
                <td>2 hr 43 mins</td>
                <td>21 hr 43 mins</td>
              </tr>
              <tr>
                <td>2.</td>
                <td>Rahul Singh</td>
                <td>3 hr 08 mins</td>
                <td>14 hr 43 mins</td>
              </tr>
              <tr>
                <td>3.</td>
                <td>Ronak Tapadia</td>
                <td>5 hr 18 mins</td>
                <td>18 hr 43 mins</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12 headboxes">
        <div class="card p-0">
          <div class="card-block p-0">
            <div
              class="heading-box"
              style="background-image: url(assets/img/part.png)"
            >
              <div class="row align-items-center">
                <div class="col-md-8">
                  <div class="pagename">
                    <h3 class="card-title">
                      Total Hours of Mentorship Provided by Mentor
                    </h3>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="total-count">
                    <h5 class="m-0">Total</h5>
                    <h2>{{ mentorshipTotal }}</h2>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="excel">
                    <button
                      type="button"
                      *ngIf="exl"
                      title="XL"
                      class="btn btn-primary addbtn ml-3"
                      (click)="exportToExcel()"
                    >
                      <i class="fa fa-file-excel-o"></i>Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-block">
            <div id="table" class="table-responsive">
              <table
                datatable
                [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger"
                class="table"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Mentor Name</th>
                    <th>Average Meeting Time</th>
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody *ngIf="mentorshipList?.length != 0">
                  <tr
                    *ngFor="let item of mentorshipList; let i = index"
                    [attr.data-index]="i"
                  >
                    <td>{{ getRowNumber(i) }}</td>
                    <td style="width: 18%">{{ item.topic }}</td>
                    <td>{{ item.mentor_name }}</td>
                    <td>{{ item.mentee_name }}</td>
                  </tr>
                </tbody>
                <tbody *ngIf="mentorshipList?.length == 0">
                  <tr>
                    <td colspan="4" class="no-data-available text-center">
                      No data available!
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
